import * as React from 'react';
const SvgWordpress = (props) => (
  <svg viewBox="0 0 69 69" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.883 34.353c0 11.665 6.779 21.746 16.609 26.523L7.434 22.36a29.36 29.36 0 0 0-2.551 11.994ZM54.247 32.866c0-3.642-1.308-6.165-2.43-8.128-1.494-2.428-2.894-4.483-2.894-6.911 0-2.71 2.055-5.23 4.949-5.23.13 0 .254.015.382.023a29.361 29.361 0 0 0-19.901-7.737C24.057 4.883 15 10.166 9.73 18.167c.692.02 1.343.035 1.897.035 3.082 0 7.854-.374 7.854-.374 1.588-.094 1.775 2.24.189 2.428 0 0-1.597.188-3.373.28l10.731 31.922 6.45-19.342-4.592-12.58c-1.587-.094-3.09-.282-3.09-.282-1.588-.093-1.402-2.52.186-2.427 0 0 4.867.374 7.763.374 3.081 0 7.853-.374 7.853-.374 1.59-.094 1.777 2.24.19 2.427 0 0-1.6.188-3.374.281l10.65 31.68 2.94-9.822c1.274-4.077 2.243-7.004 2.243-9.527Z"
      fill="#464342"
    />
    <path
      d="m34.87 36.93-8.842 25.695a29.468 29.468 0 0 0 18.111-.47 2.58 2.58 0 0 1-.21-.406L34.87 36.93ZM60.212 20.214c.126.938.198 1.946.198 3.03 0 2.99-.558 6.352-2.24 10.556l-9.003 26.027c8.762-5.11 14.655-14.601 14.655-25.474 0-5.123-1.309-9.942-3.61-14.14Z"
      fill="#464342"
    />
    <path
      d="M34.353 0C15.41 0 0 15.41 0 34.353c0 18.944 15.411 34.354 34.353 34.354 18.941 0 34.354-15.41 34.354-34.354C68.707 15.41 53.294 0 34.353 0Zm0 67.133c-18.073 0-32.778-14.705-32.778-32.78 0-18.074 14.704-32.778 32.778-32.778 18.072 0 32.776 14.704 32.776 32.778 0 18.075-14.704 32.78-32.776 32.78Z"
      fill="#464342"
    />
  </svg>
);
export default SvgWordpress;
